import { GuardChain } from './guardChain';

export class Guard {
  private constructor() {
    // intentionally empty
  }

  static that<T>(value: T, name: string): GuardChain<T> {
    return new GuardChain(value, name);
  }
}
